import { apiRequest } from "./apiRequest";
import { errorHandler } from "./errorHandler";

export const deleteWebsite = async (id: number): Promise<string> => {
  try {
    const data = await apiRequest<{ message: string }>(
      "delete",
      `/websites/${id}`
    );
    return data.message;
  } catch (error) {
    errorHandler(error);
    throw new Error("Failed to delete user");
  }
};
